import { IonContent, IonPage } from '@ionic/react';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

import AddPetButton from '../../components/Pet/AddPetButton';
import Pet from '../../components/Pet/Pet';
import Tutorial from '../../components/Tutorial/Tutorial';
import AddFirstPet from '../../components/UI/AddFirstPet';
import Alert from '../../components/UI/Alert';
import HomePetActionsGrid from '../../components/UI/HomePetActionsGrid';
import Modal from '../../components/UI/Modal';
import PageRefresher from '../../components/UI/PageRefresher';
import Spinner from '../../components/UI/Spinner';
import { useHomePage } from '../../hooks/Helpers/useHomePage';
import { Pet as PetType } from '../../types/Pet/types';
import './Home.scss';

const HomePage: React.FC = () => {
  const {
    user,
    pets,
    currentPet,
    sortedPets,
    isLoading,
    isRefreshing,
    swiperConfig,
    modal,
    alert,
    petActions,
    handlePetSelect,
    handleRefresh,
    showPersonalDataAlert,
    handleAddPet,
  } = useHomePage();

  const addPetSlide = sortedPets.length > 0 && (
    <SwiperSlide>
      <AddPetButton onClick={handleAddPet} />
    </SwiperSlide>
  );

  const petSlides = sortedPets.map((pet: PetType, index: number) => (
    <SwiperSlide key={pet.id}>
      <Pet pet={pet} setCurrentPet={handlePetSelect} isCurrent={index === 0} />
    </SwiperSlide>
  ));

  if (isLoading && !isRefreshing) {
    return <Spinner fullscreen />;
  }

  return (
    <IonPage className="home-page">
      <IonContent className="home-page__content" fullscreen>
        <PageRefresher callback={handleRefresh} />

        <section className="home-page__section ion-padding-top">
          <div className="ion-padding-horizontal" data-tut="reactour__pets_list">
            <h1>Mis Mascotas</h1>

            <Swiper {...swiperConfig}>
              {addPetSlide}
              {petSlides}
            </Swiper>
          </div>

          {pets?.length ? (
            <HomePetActionsGrid pet={currentPet} actions={petActions} />
          ) : (
            <div className="home-page__no-pets">
              <AddFirstPet onClick={!user ? showPersonalDataAlert : handleAddPet} />
            </div>
          )}
        </section>

        <Tutorial />

        <Modal isOpen={modal.isOpen} onClose={modal.closeModal} {...modal}>
          {modal.content}
        </Modal>

        <Alert
          isOpen={alert.isOpen}
          header={alert.header}
          message={alert.message}
          buttons={alert.buttons}
          onDidDismiss={alert.hideAlert}
        />
      </IonContent>
    </IonPage>
  );
};

export default HomePage;
